export class DefaultShipmentDimensions
{
    length: number;
    width: number;
    height: number;
    volume: number;
}